/** Storage keys that record which product tours have already been completed. */
export const LEGACY_PRODUCT_TOUR_COMPLETED_STORAGE_KEY = "adora-tour-completed";
export const PRODUCT_TOURS_COMPLETED_STORAGE_KEY = "adora:tours-completed";

/**
 * Callouts the user has dismissed. Kept apart from the completed record so the two stay legible:
 * completing one means the user worked through it, dismissing means they waved it away. Both stop
 * it coming back.
 */
export const PRODUCT_TOURS_DISMISSED_STORAGE_KEY = "adora:tours-dismissed";

/** Non-sensitive UX preferences that should survive an authentication logout. */
export const PRODUCT_TOUR_STORAGE_KEYS = [
  LEGACY_PRODUCT_TOUR_COMPLETED_STORAGE_KEY,
  PRODUCT_TOURS_COMPLETED_STORAGE_KEY,
  PRODUCT_TOURS_DISMISSED_STORAGE_KEY
] as const;
